import module from 'viaticos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ViaticosSharedColaboradorElegirComponent {
  data
  proyectos
  onClose
  onSelect
  colaboradores = []
  mostrar_colaboradores = false
  proyectoValido = undefined
  totalResponsables = 0

  constructor (ViaticosCatalgosProyectoColaboradoresService) {
    this.ViaticosCatalgosProyectoColaboradoresService = ViaticosCatalgosProyectoColaboradoresService
  }

  $onInit () {
    this.validar()
    this.traerEmpleados(true)
  }

  traerEmpleados (prevalidado = false) {
    if (!prevalidado) this.validar()
    if (!this.totalResponsables) return
    this.ViaticosCatalgosProyectoColaboradoresService.get(this.data.id_proyecto)
      .then(({data}) => {
        this.colaboradores = orderBy(data, 'colaborador')
        this.mostrar_colaboradores = true
      })
  }

  seleccionar () {
    this.onClose({$event: {detail: this.data}})
  }

  regresar () {
    let response = this.proyectoValido ? this.data : {}
    this.onClose({$event: {detail: response}})
  }

  validar () {
    if (!this.data) return
    this.proyectoValido = this.proyectos.find((proyecto) => proyecto.id === this.data.id_proyecto) || null
    this.totalResponsables = this.proyectoValido ? this.proyectoValido.total_responsables : 0
  }
}

module.component('viaticosSharedColaboradorElegir', {
  controller: ViaticosSharedColaboradorElegirComponent,
  template,
  bindings: {
    data: '<',
    proyectos: '<',
    onClose: '&',
    onSelect: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/shared/colaborador/elegir/component.js